import Market from '@/creditflowresearch/domain/Market/Market';
import Region from '@/creditflowresearch/domain/Region';
import Segment from '@/creditflowresearch/domain/Segment';
import { MarketName, MarketAbbreviations } from '@/creditflowresearch/domain/Market/types/MarketType';
import { CORPORATE_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import { US_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class UsMarket extends Market {
  static readonly MARKET_ID: string = US_MARKET_ID;

  static readonly NAME: MarketName = MarketName.US_MARKET;

  static readonly ABBREVIATION: MarketAbbreviations = MarketAbbreviations.US_MARKET;

  isVisible(): boolean {
    return true;
  }

  isBeta(): boolean {
    return false;
  }

  getSegments(): Segment[] {
    return CORPORATE_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  protected getRegionIdForMarket(): string | null {
    return Region.USOA_ID;
  }
}

export default UsMarket;
